'use client';

import { startBugsnag } from '@/lib/bugsnag';
import { useEffect } from 'react';

export const BugSnagInit = () => {
  useEffect(() => {
    startBugsnag();
  }, []);

  return null;
};
